module.exports = __webpack_public_path__ + "static/media/table-tennis.213b41b9.svg";